import { render, staticRenderFns } from "./FileAnswerPreview.vue?vue&type=template&id=22c257b2&scoped=true&"
import script from "./FileAnswerPreview.vue?vue&type=script&lang=js&"
export * from "./FileAnswerPreview.vue?vue&type=script&lang=js&"
import style0 from "./FileAnswerPreview.vue?vue&type=style&index=0&id=22c257b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c257b2",
  null
  
)

export default component.exports